// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"98f50947d6ce1fb2","400":"2dc79d8145a3ae51"}[chunkId] + ".js";
};